import { Form, SidebarModal } from '@domain-group/suit-theme'

import useArtworkPages from '@hooks/useArtworkPages'

import { formatEntityCount } from '@functions/entity'

import type { OrderItemModel } from '@models/types'

import ImageGrid from '../ImageGrid'
import Overlays from '../Overlays'

interface OrderArtworkProps {
  orderItem: OrderItemModel,
}

const OrderArtwork = (props: OrderArtworkProps) => {
  const { orderItem } = props

  const artworkPagesPayload = useArtworkPages({ filters: { artwork_id: orderItem?.artwork_id } })
  const {
    filteredArtworkPages,
    filteredArtworkPagesCount,
  } = artworkPagesPayload

  const artworksText = formatEntityCount({
    entityCount: filteredArtworkPagesCount,
    entityString: 'Order Artwork',
  })

  const overlays = filteredArtworkPages.map(page => page.overlays || []).flat()

  return (
    <SidebarModal.ExpandableSectionBox
      boxProps={{ backgroundColor: 'white', marginTop: 'large' }}
      headerBoxProps={{ paddingX: 0, paddingTop: 0 }}
      contentBoxProps={{ paddingX: 0 }}
      label={artworksText}
    >
      <Form.Field label="Artwork">
        <ImageGrid
          downloadPath="previews.large"
          entityArray={filteredArtworkPages}
          urlPath="previews.thumb"
        />
      </Form.Field>

      {!!overlays.length && (
        <Overlays overlays={overlays} />
      )}
    </SidebarModal.ExpandableSectionBox>
  )
}

export default OrderArtwork
